'use client'

// 禁用 IndexedDB 调试日志
if (typeof window !== 'undefined' && window.indexedDB) {
    // @ts-ignore
    window.indexedDB.debug = false;
}

import { storeUtils } from '@fanfanlo';
import AppContainer from "@src/components/app/AppContainer";
import { AppProps } from "next/app";
import '../../globals.css';
import '../css/app.scss';




const s = storeUtils.namespace('test')



function MyApp({ Component, pageProps }: AppProps) {
 
  
  return (
    <>
      <AppContainer {...pageProps} Component={Component} />
    </>
  );
}
export default MyApp;
